import React from 'react';

/** ************* COMPONENTS  ******************** */
import {
    Box,HStack, Tag, Link, Flex
} from '@chakra-ui/react';
import BackButton from 'components/Button/BackButton';
import RefreshIcon from 'components/icons/RefreshIcon';
import { useGetBulkInviteDetailsQuery } from 'reducers/realtor.service';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { LENDER_TYPE } from 'constants/index';
import { FaExternalLinkAlt } from 'react-icons/fa';
import TabField from 'components/dataDispaly/TabField';
import { viewDateAndTime } from 'utils/date';
import { getAddressString , getStateView } from 'utils/address';
import InviteStatus from 'components/Status/InviteStatus';

export default function LenderInvitationDetails() {
    const params = useParams();
    const invitationId = params.id;

    const { data, refetch } = useGetBulkInviteDetailsQuery({ invitationId , USERTYPE: LENDER_TYPE });
    const company = data?.companyInfo || {};
    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                <BackButton />
                <span>Back</span>
                <Box flex={1} textAlign={'end'}>
                    <RefreshIcon handleRefresh={ refetch}/>
                </Box>
            </div>

            <HStack
                width={'100%'}
                gap={'1rem'}
                mb="1rem"
                alignItems={'start'}
                mt={'1rem'}
            >

                <Box flex={1} p={4} borderRadius="lg" boxShadow="md" border="1px solid #E2E8F0" bg="white">

                    <div>
                        <div
                            className="preview-heading"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px',
                                borderBottom: '1px solid #e0e0e0',
                                paddingBottom: '8px'
                            }}
                        >
                            <p
                                style={{
                                    fontWeight: '600',
                                    fontSize: '13px',
                                    textTransform: 'uppercase',
                                    color: 'black'
                                }}
                            >
                            Personal Information
                            </p>

                        </div>
                        <div className="preview-body">
                            <div style={{ lineHeight: '2.5rem' }}>
                                <p><strong>Email</strong><br />  <Link href={'mailto:' + data?.Email} color='brand.500'>
                                    {data?.Email}
                                </Link>
                                </p>
                                <p><strong>First Name</strong><br />{data?.FirstName || 'N/A'}</p>
                                <p><strong>Last Name</strong><br />{data?.LastName || 'N/A'}</p>
                                <p><strong>Status</strong>
                                </p>
                                <InviteStatus status={data?.invitationStatus || ''}/>
                                <p><strong>NMLS</strong><br />{data?.NMLS || 'N/A'}</p>
                                <p><strong>State Licenses</strong><br /></p>

                                {
                                    (data && data?.Statelicenses?.length > 0 && data?.Statelicenses?.map((state,index)=>(
                                        <Tag colorScheme='teal' key={index} m={2} size='md'>{state.label || getStateView(state)}</Tag>
                                    ))) || <TabField value={<p>Doesn&apos;t have any state license</p>}/>
                                }

                                <p><strong>Address</strong><br />{getAddressString(data?.Address)}</p>
                                <p><strong>Sent On</strong><br />{viewDateAndTime(data?.createdAt)}</p>

                                <p><strong>Last Updated On</strong><br />{viewDateAndTime(data?.updatedAt)}</p>
                            </div>

                        </div>                                </div>
                </Box>
                <Box
                    p="4"
                    h={'110vh'}
                    flex={1}
                    borderRadius="lg"
                    boxShadow="md"
                    border="1px solid #E2E8F0"
                    bg="white"
                >
                    <div>
                        <div
                            className="preview-heading"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px',
                                borderBottom: '1px solid #e0e0e0',
                                paddingBottom: '8px'
                            }}
                        >
                            <p
                                style={{
                                    fontWeight: '600',
                                    fontSize: '13px',
                                    textTransform: 'uppercase',
                                    color: 'black'
                                }}
                            >
                            Company Details
                            </p>
                        </div>
                        <div className="preview-body">
                            <div style={{ lineHeight: '2.5rem' }}>
                                <p><strong>Company Email</strong><br />{ <Link href={'mailto:' + company?.companyEmail} color='brand.500'>
                                    {company?.companyEmail}
                                </Link> ||
                                                                                    'N/A'}</p>

                                <p><strong>Company Name</strong><br />{company?.companyName}</p>
                                <p><strong>Company Phone</strong><br />{company?.companyPhone || 'N/A'}</p>

                                <p><strong>Company NMLS </strong><br />{company?.NMLS || 'N/A'}</p>
                                <p><strong>Company Fax</strong><br />{company?.fax || 'N/A'}</p>
                                <p><strong>Company Website </strong><br />{<Link target='_blank' rel="noopener noreferrer" href={ (data?.website && data?.website.includes('https://') ? data?.website : 'https://' + data?.website)} color='brand.500'>
                                    <Flex align="center" gap={1}>
                                        {company?.website || 'N/A'}
                                        {
                                            company?.website && <FaExternalLinkAlt/>
                                        }
                                    </Flex>
                                </Link> || 'N/A'}</p>

                                <p><strong>Company Address</strong><br />{getAddressString(company?.Address) || 'N/A'}</p>
                                <p><strong>Updated At</strong><br />{viewDateAndTime(data?.updatedAt) || 'N/A'}</p>
                            </div>
                        </div>
                    </div>

                </Box>
            </HStack>
        </Box>
    );
}
